import React from 'react';
import Header from '../components/common/Header';
import Footer from '../components/common/Footer';
import LandingHomePage from '../components/landing/HomePage';

const HomePage = () => {
  return (
    <>
      <Header />
      <LandingHomePage />
      <Footer />
    </>
  );
};

export default HomePage;